import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { getItemWebStorage } from "src/features/webStorageSaver";

type ConfigSlice = {
    fullConfig: any,
    fullConfigIsLoading: boolean,
    startPageUrl: string
}

export const DEFAULT_START_PAGE_URL = '/app/roads/list';

export function resolveStartPageUrl(value?: string, fallback = DEFAULT_START_PAGE_URL) {
    const trimmedValue = value?.trim()
    if (!trimmedValue) return fallback
    const normalizedValue = trimmedValue.length > 1 ? trimmedValue.replace(/\/+$/, '') : trimmedValue
    if (normalizedValue === '/' || normalizedValue === '/app') {
        return fallback
    }
    return normalizedValue
}

const initialState: ConfigSlice = {
    fullConfig: null,
    fullConfigIsLoading: false,
    startPageUrl: resolveStartPageUrl(getItemWebStorage('currentConfig')?.startPageUrl)
}

export const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {
        setFullConfig(state, action: PayloadAction<string>) {
            state.fullConfig = action.payload
        },
        setFullConfigIsLoading(state, action: PayloadAction<boolean>) {
            state.fullConfigIsLoading = action.payload
        },
        setStartPageUrl(state, action: PayloadAction<string | undefined>) {
            state.startPageUrl = resolveStartPageUrl(action.payload)
        },
    }
})

export const { setFullConfig, setFullConfigIsLoading, setStartPageUrl } = configSlice.actions
export const configReducer = configSlice.reducer;
